module.exports = __webpack_public_path__ + "static/img/indexbg1.77eeaf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexbg1.png
// module id = n2ev
// module chunks = 1